import React, { useEffect, useRef, useState } from "react";
import "./TransferRequest.css";
import { Sorting } from "../../../../../components/Lists/Sorting";
import Skeleton from "react-loading-skeleton";
import { ResultsNotFound } from "../../../../../components/ResultsNotFound/ResultsNotFound";
import { Tooltip } from "@mui/material";
import Input from "../../../../../components/Inputs/Input";
import {
  createTransferPartRequest,
  getPartRequestSupplyChainListTranser,
} from "../../../Services/PartRequestManagementService";
import { HTTP_RESPONSE_CODES } from "../../../../../globals/globals";
import { getUserCompanyId } from "../../../../../services/authService";
import { useSnackBar } from "../../../../../hooks/useSnackBar";

export const TransferRequest = ({ part, location, onClose }) => {
  const { infoMsg, successMsg, warningMsg, errorMsg } = useSnackBar();
  const propertyRefs = useRef({});
  const [tooltips, setTooltips] = useState({});
  const listRef = useRef(null);
  const [loadingAvailableParts, setLoadingAvailableParts] = useState(false);
  const getSortingOrder = (order) => {};
  const handleScroll = (event) => {
    const { scrollTop, clientHeight, scrollHeight } = event.currentTarget;
    if (scrollHeight - (scrollTop + 3) <= clientHeight) {
      //if (!setLoadingPartsReq) requestNextPage();
    }
  };
  const [cantToRequest, setCantToRequest] = useState(0);
  const pageSize = 10;
  const [page, setPage] = useState(0);
  const [maxPages, setMaxPages] = useState(null);
  const [dataList, setDataList] = useState([]);
  const [search, setSearch] = useState("");
  const [sortingOrder, setSortingOrder] = useState("quantity");
  useEffect(() => {
    setLoadingAvailableParts(true);
    getPartRequestSupplyChainListTranser(
      page,
      pageSize,
      search,
      sortingOrder,
      part.part_id,
      location.location_id,
      part.pr_location_id
    )
      .then((response) => {
        if (response.data.responseCode === HTTP_RESPONSE_CODES.SUCCESS) {
          setMaxPages(response.data.totalPages);
          let inventoryArray = response.data.load.map((item) => ({
            ...item,
            date_request_required: item.date_request_required.split("T")[0],
            status: !item.available_quantity
              ? "error"
              : item.available_quantity >= item.remaining_quantity
              ? "success"
              : "warning",
          }));

          setDataList(inventoryArray);
          setLoadingAvailableParts(false);
        }
      })
      .catch((error) => setLoadingAvailableParts(false));
  }, [page, search, sortingOrder]);
  useEffect(() => {
    const newTooltips = {};
    Object.entries(propertyRefs.current).forEach(([key, el]) => {
      if (el) {
        newTooltips[key] = el.scrollWidth > el.clientWidth;
      }
    });
    setTooltips(newTooltips);
  }, [dataList]);

  const createTransferRequest = async () => {
    //Validations here return

    const payLoad = [];
    const mainPr = {
      companyId: parseInt(getUserCompanyId()),
      locationId: part.pr_location_id,
      siteId: part.pr_site_id,
      aircraftId: part.aircraft_id,
      workPackageId: part.work_package_id,
      dateRequestCreated: new Date(),
      dateRequestRequired: part.date_request_required,
      customerId: part.customer_id,
      description: "",
      status: "Posted",
      version: 0,
      partRequestType: "Transfer",
      originLocationId: location.location_id,
      originSiteId: location.site_id,
      partRequestDetailParts: [
        {
          taskCardId: part.reference_id,
          findingId: null,
          quantity: cantToRequest,
          uomId: part.uom_id,
          companyId: parseInt(getUserCompanyId()),
          partId: part.part_id,
        },
      ],
    };
    payLoad.push(mainPr);
    dataList.forEach((item) => {
      if (item.cantToTransfer != null && item.cantToTransfer > 0) {
        const pr = {
          companyId: parseInt(getUserCompanyId()),
          locationId: item.pr_location_id,
          siteId: item.pr_site_id,
          aircraftId: item.aircraft_id,
          workPackageId: item.work_package_id,
          dateRequestCreated: new Date(),
          dateRequestRequired: item.date_request_required,
          customerId: item.customer_id,
          description: "",
          status: "Posted",
          version: 0,
          partRequestType: "Transfer",
          originLocationId: location.location_id,
          originSiteId: location.site_id,
          partRequestDetailParts: [
            {
              taskCardId: item.reference_id,
              findingId: null,
              quantity: item.cantToTransfer,
              uomId: item.uom_id,
              companyId: parseInt(getUserCompanyId()),
              partId: item.part_id,
            },
          ],
        };
        payLoad.push(pr);
      }
    });
    createTransferPartRequest(payLoad)
      .then((response) => {
        if (response.data.responseCode === HTTP_RESPONSE_CODES.SUCCESS) {
          successMsg("Part Request Created", "Saved Successfully");
          onClose();
        }
      })
      .catch((error) => {
        console.error(error);
      })
      .finally(() => {});
  };

  const handleQTYToIssueChangeItem = (item, key, e) => {
    const newQTY = e.target.value;
    setDataList((prev) =>
      prev.map((p) => (p.id === item.id ? { ...p, [key]: newQTY } : p))
    );
  };
  const handleQTYToIssueChange = (e) => {
    const newQTY = e.target.value;
    setCantToRequest(newQTY);
  };
  return (
    <div className="transfer-request-full-container">
      <div className="transfer-request-header">
        <div className="transfer-request-header-info">
          <h3>Transfer Request</h3>
          <div className="transfer-request-part-info">
            <div className="transfer-request-part-info-item">
              <p>PN</p>
              <b>{part.part_number}</b>
            </div>
            <div className="transfer-request-part-info-item">
              <p>PRN</p>
              <b>{part.id}</b>
            </div>
            <div className="transfer-request-part-info-item">
              <p>WP</p>
              <b>{part.work_package_id}</b>
            </div>
            <div className="transfer-request-part-info-item">
              <p>QTY Requested</p>
              <b>5 EA</b>
            </div>
          </div>
        </div>
        <button className="outlined icon small-size" onClick={onClose}>
          <i className="icon-cross"></i>
        </button>
      </div>
      <hr />
      <div className="transfer-request-origin-destination">
        <div className="transfer-request-origin-container activate">
          <div className="transfer-request-origin-left">
            <i className="icon-airport-new"></i>
            <b>Transfer Origin</b>
            <p>Where the part is coming from</p>
          </div>
          <div className="transfer-request-origin-right">
            <div className="transfer-request-origin-right-item">
              <b>Location</b>
              <p>{location.location_name}</p>
            </div>
            <div className="transfer-request-origin-right-item">
              <b>Site</b>
              <p>{location.site_name}</p>
            </div>
            <div className="transfer-request-origin-right-item">
              <b>Type</b>
              <p>{location.site_type}</p>
            </div>
            <div className="transfer-request-origin-right-item">
              <b>QTY Available</b>
              <p>{location.quantity + " " + location.uom_abrevation}</p>
            </div>
          </div>
        </div>
        <div className="transfer-request-origin-container">
          <div className="transfer-request-origin-left">
            <i className="icon-airport-new"></i>
            <b>Transfer Destination</b>
            <p>Where the part is going</p>
          </div>
          <div className="transfer-request-origin-right">
            <div className="transfer-request-origin-right-item">
              <b>Location</b>
              <p>{part.pr_location_name}</p>
            </div>
            <div className="transfer-request-origin-right-item">
              <b>Site</b>
              <p>{part.pr_site_name}</p>
            </div>
            <div className="transfer-request-origin-right-item">
              <b>Type</b>
              <p>{part.site_type}</p>
            </div>
            <div className="transfer-request-origin-right-item">
              <b>QTY To Transfer</b>
              <div
                className="input-transfer-container"
                style={{ width: "6rem" }}
              >
                <Input
                  name="quantity_issue"
                  disableAutocomplete={true}
                  placeholder={""}
                  label={""}
                  limit={location.quantity}
                  disabled={false}
                  isNumeric={true}
                  value={cantToRequest}
                  onChange={(e) => handleQTYToIssueChange(e)}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <b className="sub-title-transfer">Additional PRN(s)</b>
      <div className="sorting-header">
        <div className="sorting-free-slot"> </div>
        <Sorting
          onOrderChange={getSortingOrder}
          ignoreProperties={true}
        showHeaderOrder={true}
          displayButton={false}
          properties={{
            id: "PRN",
            part_number: "PN",
            other_locations_avl: "Origin Available",
            remaining_quantity: "Remaining",
            quantity: "Required",
            issued_quantity_posted: "Issued",
            pending_order: "Pending Order",
            pending_transfer: "Pending Transfer",
            work_package_id: "WP",
            reference_id: "TC/FND",
            date_request_required: "Required Date",
            qty_to_transfer: "Qty to Transfer",
          }}
        ></Sorting>
      </div>
      <div
        className="company-transfer-list"
        ref={listRef}
        onScroll={handleScroll}
      >
        {loadingAvailableParts ? (
          // Mostrar esqueletos mientras carga
          Array.from({ length: 7 }).map((_, idx) => (
            <div key={idx} className="item-container-skeleton">
              <Skeleton
                style={{ borderRadius: "10px" }}
                height="1.68rem"
                width={40}
              />
              <div className="item-skeleton-content">
                <Skeleton height={20} width="80%" />
              </div>
              <Skeleton height={30} width="7rem" />
            </div>
          ))
        ) : dataList.length === 0 ? (
          <ResultsNotFound />
        ) : (
          dataList.map((item, idx) => (
            <React.Fragment key={`${item.id}-${idx}`}>
              <div className="item-global-tramsfer-container">
                {[
                  "id",
                  "part_number",
                  "other_locations_avl",
                  "remaining_quantity",
                  "quantity",
                  "issued_quantity_posted",
                  "pending_order",
                  "pending_transfer",
                  "work_package_number",
                  "task_card_number",
                  "date_request_required",
                ].map((label) => (
                  <div className="property" key={label}>
                    <Tooltip
                      title={tooltips[`${item.id}-${label}`] ? item[label] : ""}
                      arrow
                    >
                      <p
                        className={`light-font ${
                          !isNaN(item[label]) && isFinite(item[label])
                            ? "isNumeric"
                            : ""
                        }`}
                        ref={(el) => {
                          if (el) {
                            propertyRefs.current[`${item.id}-${label}`] = el;
                          }
                        }}
                      >
                        {item[label]}
                      </p>
                    </Tooltip>
                  </div>
                ))}

                <Input
                  name="cantToTransfer"
                  disableAutocomplete={true}
                  placeholder={""}
                  label={""}
                  disabled={false}
                  limit={item["other_locations_avl"]}
                  isNumeric={true}
                  value={item["cantToTransfer"]}
                  onChange={(e) =>
                    handleQTYToIssueChangeItem(item, "cantToTransfer", e)
                  }
                />
              </div>
            </React.Fragment>
          ))
        )}
      </div>
      <div className="transfer-request-footer">
        <button
          className="transfer-button-color"
          onClick={() => createTransferRequest()}
        >
          Create Transfer Request
        </button>
      </div>
    </div>
  );
};
